import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=fed31d92&scoped=true&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=fed31d92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed31d92",
  null
  
)

export default component.exports